import { defineComponent as _defineComponent } from 'vue'
import { customMoment } from "@/main";
import { useRootStore } from "@/store/pinia";
import { useTranslation } from "@/store/translation";
import { computed } from "vue";
import { useAnnouncementsQuery } from "@/api/settingsQueries";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { $t } = useTranslation();
const appMode = computed(() => useRootStore().appMode);

const { data: announcementsResult } = useAnnouncementsQuery(appMode);
const result = computed(() =>
  announcementsResult.value ? { announcements: announcementsResult.value } : null
);

function formatDate(dateString: string) {
  return customMoment(dateString).calendar();
}


return { __sfc: true,$t, appMode, announcementsResult, result, formatDate }
}

})